import { ProductDto } from './product.dto';
export class ProductModifierRequestDto{
    product: ProductDto;
    menuId: number;
    merchantId: number = null;
}